export default __webpack_public_path__ + "static/media/Thumb_Glasses_00.e9e313d0.png";